import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'firm_resettlement'
const storeType = 'firmResettlements'

export const PEFirmResettlementsCardActions = {
  initPeFirmResettlementsCard: ({ commit }, index) => {
    commit('setPeFirmResettlementsCardLock', { index, lock: true })
  },
  peFetchFirmResettlementsCards: async ({ commit, getters }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peFirmResettlementsCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            country_id: section.country_id,
            offer_of_permanent_residence: section.offer_of_permanent_residence,
            citizenship: section.citizenship,
            other_firm_resettlement: section.other_firm_resettlement,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeFirmResettlementsCardLock', { index: 'new', lock: true })
        commit('setPeFirmResettlementsCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peFirmResettlementsCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeFirmResettlementsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peFirmResettlementsCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            country_id: section.country_id,
            offer_of_permanent_residence: section.offer_of_permanent_residence,
            citizenship: section.citizenship,
            other_firm_resettlement: section.other_firm_resettlement,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeFirmResettlementsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peFirmResettlementsCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeFirmResettlementsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peFirmResettlementsCardAddSection: ({ commit }) => {
    commit('setPeFirmResettlementsCardLock', { index: 'new', lock: false })
    commit('addPeFirmResettlementsCardSection', {
      id: null,
      country_id: null,
      offer_of_permanent_residence: false,
      citizenship: false,
      other_firm_resettlement: false,
      narrative: '',
    })
  },
  peFirmResettlementsCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PEFirmResettlementsCardMutations = {
  setPeFirmResettlementsCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.FirmResettlementsCard) {
      Vue.set(state.partyEdit.partySections, 'FirmResettlementsCard', {})
    }
    Vue.set(state.partyEdit.partySections.FirmResettlementsCard, index, lock)
  },
  addPeFirmResettlementsCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peFirmResettlementsCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.FirmResettlementsCard, 'new', true)
  },
}

export const PEFirmResettlementsCardGetters = {
  peFirmResettlementsCardLock: state => index => state.partyEdit.partySections.FirmResettlementsCard[index],
  peFirmResettlementsCardHasNewSection: state => !!state.
    partyEdit.
    asylumAssystant[storeType]?.
    find(firmResettlement => firmResettlement.id === null),
}
